import { render, staticRenderFns } from "./TransectItem.vue?vue&type=template&id=89ebac22&scoped=true"
import script from "./TransectItem.vue?vue&type=script&lang=js"
export * from "./TransectItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89ebac22",
  null
  
)

export default component.exports